/** Save a Blob to the user's downloads as `filename` (deferred revoke so the download isn't aborted). */
export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  setTimeout(() => {
    try {
      URL.revokeObjectURL(url);
    } catch {
      // URL may be gone (test teardown); the browser reclaims it anyway
    }
  }, 0);
}

/** Filename from a `Content-Disposition` header, preferring RFC 5987 `filename*=` over `filename=`. */
export function filenameFromContentDisposition(
  disposition: string | null,
  fallback: string,
): string {
  if (!disposition) return fallback;
  const star = disposition.match(/filename\*=(?:UTF-8'')?([^;]+)/i);
  if (star) {
    try {
      return decodeURIComponent(star[1].trim().replace(/^"|"$/g, ''));
    } catch {
      // malformed encoding — fall back to plain filename=
    }
  }
  const plain = disposition.match(/filename="?([^";]+)"?/i);
  return plain ? plain[1] : fallback;
}
